// extracted by mini-css-extract-plugin
export default {"desktopList":"style_desktopList__wh-i5","link":"style_link__oXBKn","mobileNavigationList":"style_mobileNavigationList__Kznc6","open":"style_open__tf9Ul"};